  require('./facts-slider.component.scss');
  import {
    Fact
  } from '../../common/fact';

  class FactsSliderController {
    constructor($scope, $element, $timeout, $interval, LayoutService) {
      this.$scope = $scope;
      this.$element = $element;
      this.$interval = $interval;
      this.$timeout = $timeout;
      this.isImage = Fact.isImage;
      this.getFactType = Fact.getFactType;
      this.getImageFileName = Fact.getImageFileName;
      this.getVideoFileName = Fact.getVideoFileName;
      this.enableWatchModel = true;
      this.playing = false;
      this.playingDelay = 3;
      this.playingID = null;
      this.movedId = -1;
      this.loading = false;
      this.isZoom = LayoutService.options.isZoomedScreenshotViewer.value;

      this.$scope.$on('FilterDataLoaded', () => {
        this.loading = true;
        this.updateFactThumb();

        $timeout(() => {
          this.animateForward(() => {
            this.loading = false;
            this.updateFactThumb();
          });
        });
      });

      this.$scope.$on('videoStarted', (e) => {
        if (this.playing)
          this.pauseUntilLoading();
      });
      this.$scope.$on('videoEnded', (e) => {
        if (this.playing) {
          this.next();
          this.play();
        }
      });

      this.keyboardEvents = {
        13: () => {}, // Enter
        27: () => {}, // Esc
        32: () => {
          this.leaf(1);
        }, // Space
        33: () => {
          this.leaf(-5);
        }, // PgUp
        34: () => {
          this.leaf(5);
        }, // PgDown
        35: () => {
          this.leafToLast();
        }, // End
        36: () => {
          this.leafToFirst();
        }, // Home
        37: () => {
          this.leaf(-1, true);
        }, // Left
        38: () => {
          this.leaf(-1);
        }, // Up
        39: () => {
          this.leaf(1, true);
        }, // Right
        40: () => {
          this.leaf(1);
        } // Down
      };

      $timeout(() => {
        $('.showImageModal').removeClass('modal');
        const windowHeight = $(window).height();
        const timelineHeight = $('.imageDialogTimeline').height();
        const imageDialogBody = $('.imageDialogBody');
        if (!imageDialogBody[0]) return;
        const imageHeight = windowHeight - imageDialogBody.offset()['top'] -
          timelineHeight - 10;
        imageDialogBody.height(imageHeight);
        const imageDialogMiddle = imageDialogBody.find('div.btn-layout-middle');
        const imageDialogImg = imageDialogMiddle.find('img');
        if (this.isZoom) {
          imageDialogMiddle.css('border', '1px dashed yellow');
          imageDialogImg.css('max-width', 'unset');
          imageDialogImg.css('max-height', imageHeight + 'px');
          imageDialogMiddle.mouseover(e => {
            imageDialogImg.css('max-height', 'unset');
          });

          imageDialogMiddle.mousemove(e => {
            let x = 0;
            let y = 0;
            if (imageDialogMiddle.width() < imageDialogImg.width())
              x = e.pageX / imageDialogMiddle.width() *
              (imageDialogMiddle.width() - imageDialogImg.width() - 150) + 100;
            if (imageDialogMiddle.height() < imageDialogImg.height())
              y = e.pageY / imageDialogMiddle.height() *
              (imageDialogMiddle.height() - imageDialogImg.height() - 150) + 100;
            imageDialogImg.css('transform', `translate(${x}px, ${y}px)`);
          });
          imageDialogMiddle.mouseout(e => {
            imageDialogImg.css('max-height', imageHeight + 'px');
            imageDialogImg.css('transform', 'translate(0, 0)');
          });
        } else {
          imageDialogImg.css('max-height', '100%');
        }
        $timeout(() => {
          $('.btn-layout-next').css({
            'line-height': '20px'
          });

        }, 100);
      }, 100);
    }

    imageUrl(fact) {
      if (!fact) return null;
      const fileName = this.getImageFileName(fact);
      if (!fileName) return null;
      if (fact['agent_attachedfile.mime'] == 'image/tiff')
        return '/analytics/thumb/' + fileName;
      return '/media/' + fileName;
    }

    $postLink() {
      $('#screenshot-image').bind('load error', () => {
        this.onImageLoad();
        this.$timeout(() => {
          this.$scope.$digest();
        }, 0);
      });
      this.$element.bind('keydown keypress', (e) => {
        this.onKeyDown(e);
      });
    }

    onKeyDown(e) {
      const code = e.which;
      if (code in this.keyboardEvents) {
        this.keyboardEvents[code]();
        e.preventDefault();
      }
    }

    scrollPrev() {
      this.enableWatchModel = false;

      if (!this.$timelineClip) this.$timelineClip = $('.timeline-container-clip');
      if (!this.containerWidth) this.containerWidth = $('.timeline-container').width();
      const offset = this.containerWidth - Math.ceil(this.containerWidth / 5);
      const thumbnalListLeft = -this.$timelineClip.position().left;
      let animateLeft;
      if (thumbnalListLeft - offset < 0) {
        animateLeft = 0;
      } else {
        animateLeft = '+=' + offset;
      }

      this.$timelineClip.animate({
        left: animateLeft,
      }, {
        // specialEasing: 'slow',
        queue: false,
        done: () => this.updateFactThumb()
      }, );
    }

    animateForward(calback) {
      this.$timelineClip.animate({
        left: '-=' + this.offset,
      }, {
        // specialEasing: 'slow',
        queue: false,
        done: calback,
      }, );
    }

    scrollNext() {
      if (this.loading || this.filterData.loading || this.filterData.loadingMore) return;
      this.enableWatchModel = false;

      if (!this.$timelineClip) this.$timelineClip = $('.timeline-container-clip');
      if (!this.containerWidth) this.containerWidth = $('.timeline-container').width();
      this.offset = this.containerWidth - Math.ceil(this.containerWidth / 5);
      if (!this.thumbnalListWidth) this.updateFactThumb();
      const thumbnalListLeft = -this.$timelineClip.position().left;
      if (thumbnalListLeft + this.offset + this.containerWidth > this.thumbnalListWidth) {
        if (this.thumbnalListWidth > this.containerWidth) {
          this.offset = this.thumbnalListWidth - this.containerWidth - thumbnalListLeft;
        } else {
          this.offset = -thumbnalListLeft;
        }
        if (!this.filter.hasOwnProperty('limit')) this.moreFacts();
      } else this.animateForward(() => this.updateFactThumb());
    }

    updateFactThumb() {
      const marginRight = this.$thumbnails && this.$thumbnails.css('margin-right') != null ?
        this.$thumbnails.css('margin-right') : '0px';
      const offsetWidth = parseInt(marginRight.substr(0, marginRight.length - 2), 10);
      this.$timelineClip = $('.timeline-container-clip');
      this.$thumbnails = $('.thumbnail-layout');
      this.containerWidth = $('.timeline-container').width();
      const selectedPos = this.$timelineClip.position().left;
      const containerWidth = this.containerWidth;
      const facts = this.filterData.filterData;
      let thumbListWidth = 0;
      this.$thumbnails.each(function(index) {
        const thumbPos = this.offsetLeft;
        if (!facts[index]) return;
        facts[index].showFactThumb = thumbPos + selectedPos + containerWidth >= 0 &&
          thumbPos + selectedPos <= containerWidth * 2;
        if (facts[index].showFactThumb || this.style.width) {
          if (!this.style.width) this.style.width = `${this.offsetWidth}px`;
          thumbListWidth += this.offsetWidth + offsetWidth;
        } else thumbListWidth += thumbListWidth / (index + 1);
      });
      this.thumbnalListWidth = thumbListWidth;
      if (!this.$scope.$root.$$phase) this.$scope.$digest();

    }

    getX(fact) {
      this.$thumbnails = $('.thumbnail-layout');
      const marginRight = this.$thumbnails.css('margin-right') != null ?
        this.$thumbnails.css('margin-right') : '0px';
      const offsetWidth = parseInt(
        marginRight.substr(0, marginRight.length - 2), 10) - 0.514;
      if (!this.containerWidth) this.containerWidth = $('.timeline-container').width();
      let thumbListWidth = 0;
      let thumbByIndexWidth = 0;
      const eventIndex = this.getIndex();
      this.$thumbnails.each(function(index) {
        const thumbWidth = this.offsetWidth + offsetWidth;
        if (index < eventIndex) {
          thumbByIndexWidth += thumbWidth;
        } else if (index == eventIndex) {
          thumbByIndexWidth += Math.ceil(thumbWidth / 2);
        }
      });
      thumbListWidth = this.thumbnalListWidth;
      let pos = 0;
      if (thumbByIndexWidth > this.containerWidth / 2) {
        if (thumbListWidth - thumbByIndexWidth < this.containerWidth / 2) {
          pos = -(thumbListWidth - this.containerWidth);
        } else {
          pos = -(thumbByIndexWidth - this.containerWidth / 2);
        }
      }
      if (pos > 0) {
        pos = 0;
      }
      return pos;
    }

    move(fact) {
      if (this.movedId == fact.id) return;

      this.movedId = fact.id;
      this.$timeout(() => {
        if (!this.enableWatchModel) {
          return;
        }
        const x = this.getX(fact);
        $('.timeline-container-clip').animate({
          'left': x,
        }, {
          // specialEasing: 'slow',
          queue: false,
          done: () => this.updateFactThumb()
        }, );
      }, 200);
    }

    getIndex() {
      return this.selectedFact && this.filterData.filterData ?
        this.filterData.filterData.findIndex(f => f.id === this.selectedFact.id) : 0;
    }

    get hasPrev() {
      return this.filterData.filterData && this.filterData.filterData.length &&
        this.filterData.filterData[0].id !== this.selectedFact.id;
    }

    get hasNext() {
      return !(this.filterData.filterData && this.filterData.filterData.length && this.filterData.isComplete &&
        this.filterData.filterData[(this.filterData.filterData.length - 1)].id === this.selectedFact.id);
    }

    next() {
      this.enableWatchModel = true;
      this.leaf(1);
    }

    prev() {
      this.enableWatchModel = true;
      this.leaf(-1);
    }

    selectThumb(fact) {
      if (this.selectedFact && fact.id === this.selectedFact.id) {
        return;
      }
      this.enableWatchModel = true;
      $('#image-spinner').show();

      this.selectedFact = fact;

      if (this.playing) {
        this.pauseUntilLoading();
      }
      if (fact['agent_attachedfile.data']) {
        this.$timeout(() => {
          const thumbImage = $('#screenshot-image').get(0);
          if (!thumbImage || thumbImage.complete) {
            this.onImageLoad();
          } else {
            this.onImageLoad();
          }
        }, 10);
      } else {
        this.onImageLoad();
      }
      this.$timeout(() => {
        this.$scope.$digest();
      }, 0);
    }

    onImageLoad() {
      $('#image-spinner').hide();
      if (this.playing) {
        this.play();
      }
    }

    leaf(step, apply) {
      let eventIndex = this.getIndex();
      while (eventIndex < this.filterData.filterData.length && eventIndex >= 0) {
        eventIndex += step;
        if (eventIndex + step >= this.filterData.filterData.length) {
          this.moreFacts();
        }
        if (eventIndex >= 0) {
          const fact = this.filterData.filterData[eventIndex];
          if (fact) {
            this.selectThumb(fact);
            if (apply) {
              this.$scope.$apply();
            }
            break;
          }
        }
      }
    }

    moreFacts() {
      this.loading = true;
      return this.filterData.moreFacts();
    }

    onPlayClick() {
      this.playing = !this.playing;
      if (this.playing) {
        this.play();
      } else {
        this.stop();
      }
    }

    play() {
      this.playingDelay = $('.showImageModal .player-input').val();
      this.playing = true;
      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }

      this.playingID = this.$interval(() => {
        this.next();
      }, this.playingDelay * 1000);
    }

    pauseUntilLoading() {
      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }
    }

    stop() {
      this.playing = false;
      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }
    }

    closeDialog() {
      this.$scope.$parent.closeDialog();
      $('#image-spinner').hide();
      this.stop();
    }
  }

  export const FactSliderComponent = {
    bindings: {
      model: '<',
      filter: '<',
      filterData: '<',
      selectedFact: '<',
    },
    template: require('./facts-slider.component.html'),
    controller: FactsSliderController,
  };



// WEBPACK FOOTER //
// ./src/facts/slider/facts-slider.component.js